//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbFacet from './rb-facet.vue'
import RbSwitch from '@/elements/forms/rb-switch.vue'

export default {
  name: 'rb-toggle-facet',
  components: {
    RbSwitch,
  },
  extends: RbFacet,
  computed: {
    dataMntValue() {
      return this.active.toString()
    },
  },
}
